// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__dhgmK","floatLabelWithColorStyle":"Spinner_floatLabelWithColorStyle__qad+A","errorField":"Spinner_errorField__TQUdr"};